module.exports = __webpack_public_path__ + "427067109baa8dd7f31e9888d98bdec9.png";